const PENDING = 'pending'
const DISAPPROVED = 'disapproved'
const REVIEW_DISAPPROVED = 'review_disapproved'
const REVIEW_DPO = 'review_dpo'
const APPROVED = 'approved'
const INACTIVE = 'inactive'

const STATUSES = {
  APPROVED,
  DISAPPROVED,
  INACTIVE,
  PENDING,
  REVIEW_DISAPPROVED,
  REVIEW_DPO,
}

const liaAnswers = { STATUSES }

export default liaAnswers
